import { ResponseStatus } from '@sdbn/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { ControlContainer, NgForm, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ParamterType, SupplementaryEquipment, TruckDetails } from '../../truck.model';
import { TruckService } from '../../truck.service';

@Component({
    selector: 'app-truck-supplementary-equipment',
    templateUrl: './truck-supplementary-equipment.component.html',
    styleUrls: ['./truck-supplementary-equipment.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class TruckSupplementaryEquipmentComponent implements OnInit {

  @Input() truck = new TruckDetails();

  formGroup = new UntypedFormGroup({
    available: new UntypedFormGroup({}),
    handouted: new UntypedFormGroup({}),
  });

  availableEquipment = new Array<SupplementaryEquipment>();

  constructor(
    private truckService: TruckService,
    public translationService: TranslationService) { }

  ngOnInit(): void {
    this.setupHandoutedEquipmentForm();
    // Calculate available equipment which can be handouted
    this.truckService.getAvailableSupplementaryEquipments().subscribe(response => {
      if (response.status === ResponseStatus.SUCCESS) {
        const newAvailableEquipment = new Array<SupplementaryEquipment>();
        if (response.equipments != null) {
          response.equipments.forEach(elm => newAvailableEquipment.push(elm));
        }
        newAvailableEquipment.filter(e => !e.handouted).forEach(e => this.availableEquipment.push(e));
        this.setupAvailableEquipmentForm();
      }
    });
  }

  public getSelectedSupplementaryEquipment(): Array<SupplementaryEquipment> {
    const selectedEquipmentToHandout = new Array<SupplementaryEquipment>();
    this.availableEquipment.forEach(e => {
      if (e.selected) {
        selectedEquipmentToHandout.push(e);
      }
    });
    return selectedEquipmentToHandout;
  }

  private setupHandoutedEquipmentForm() {
      console.log('truckDetails', this.truck.equipment);
      this.truck.equipment.forEach((eq, index) => {
        const equipmentFormGroup = new UntypedFormGroup({
          selected: new UntypedFormControl(eq.selected ?? false),
          identifier: new UntypedFormControl(eq.selectedIdentifier, Validators.required),
        });
        (this.formGroup.get(['handouted']) as UntypedFormGroup).addControl('' + index, equipmentFormGroup, {emitEvent: false});
        equipmentFormGroup.controls.identifier.disable();
      });
  }

  private setupAvailableEquipmentForm() {
      this.availableEquipment.forEach((se, index) => {
        const equipmentFormGroup = new UntypedFormGroup({
          selected: new UntypedFormControl(se.selected ?? false),
          identifier: new UntypedFormControl(se.selectedIdentifier, Validators.required),
        });
        (this.formGroup.get(['available']) as UntypedFormGroup).addControl('' + index, equipmentFormGroup, {emitEvent: false});
        if ((se.selected ?? false) !== true) { // initialer Status des Formfields
          equipmentFormGroup.controls.identifier.disable({emitEvent: false});
        }
      });
      
  
      this.formGroup.valueChanges.subscribe(values => {
        this.availableEquipment.forEach((se, index) => {
          se.selected = values['available'][index].selected;
          // Unklar, warum identifier nicht in 'values' enthalten ist.
          se.selectedIdentifier = this.formGroup.get(['available', index, 'identifier'])?.value;
  
          if (se.selected && se.availableIdentifiers.length > 0) {
            this.formGroup.get(['available', index, 'identifier'])?.enable({onlySelf: true, emitEvent: false});
          }
  
        });

        this.truck.equipment.forEach((se, index) => {
          se.selected = values['handouted'][index].selected;
        });
      });
    }
}
